/**
 * QueryClient singleton — Story X1.3.3.
 *
 * Extraído de `App.tsx` pra que handlers fora de componentes (ex.: o flush da
 * fila offline) possam reconciliar o cache (`invalidateQueries`/`setQueryData`)
 * usando a MESMA instância que o `<QueryClientProvider>` da árvore React.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
